<script lang="ts" setup>
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();
const config = useRuntimeConfig();

const props = defineProps<{
  isShow: boolean
  scenarios: MessageDataScenarios[],
  language: string
}>();

/**
 * 次のシナリオを検索
 * @param scenario
 */
const nextScenarios = async (scenario: string) => {
  chatStore.search(scenario);
};
</script>

<template>
  <div v-if="props.isShow && props.scenarios.length > 0" class="mt-2">
    <template v-for="scenario in props.scenarios">
      <button type="button"
        class="bg-white border border-solid border-design-red rounded-2xl px-2 py-1 text-sm max-w-[300px] m-1 hover:bg-design-pink"
        @click="nextScenarios(scenario.text)" :class="chatStore.createLanguageClass(props.language)">
        {{ scenario.translated_text }}</button>
    </template>
  </div>
</template>